import { Injectable } from '@angular/core';
import { InveniasEntityTypes, InveniasNamespace } from 'datasource-service-lib';
import { IDataSourceApiService, IEntity } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IRecipientInfoService } from './irecipient-info.service';

// TODO: consider if we can use the IEntityProfileService instead?

@Injectable({
  providedIn: 'root',
})
export class InveniasRecipientInfoService implements IRecipientInfoService {
  private readonly dataSourceApiService: IDataSourceApiService;
  private readonly entityTypes: InveniasEntityTypes[] = [InveniasEntityTypes.People];

  constructor(serviceProviderService: SharedServiceProviderServiceFactory) {
    this.dataSourceApiService = serviceProviderService.getServiceProviderService(InveniasNamespace.name).getDataSourceApiService();
  }

  getEntityTypes(): InveniasEntityTypes[] {
    return this.entityTypes;
  }

  getEntityInfo(entity: IEntity): Observable<any> {
    return this.dataSourceApiService.get(entity).pipe(
      map((data) => {
        return {
          name: data.NameComponents.FullName,
          email: data.EmailAddresses.length > 0 ? data.EmailAddresses[0].ItemValue : '',
          role: data.DefaultPosition.JobTitle,
        };
      })
    );
  }
}
